export default __webpack_public_path__ + "static/example_deepnest-46f4274231e734997d4f77b1d1ff70ed.png";